import { render, staticRenderFns } from "./MainFileSystem.vue?vue&type=template&id=095cddfd&scoped=true&"
import script from "./MainFileSystem.vue?vue&type=script&lang=js&"
export * from "./MainFileSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095cddfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095cddfd')) {
      api.createRecord('095cddfd', component.options)
    } else {
      api.reload('095cddfd', component.options)
    }
    module.hot.accept("./MainFileSystem.vue?vue&type=template&id=095cddfd&scoped=true&", function () {
      api.rerender('095cddfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/files/MainFileSystem.vue"
export default component.exports